import gql from 'graphql-tag';

import similarIntegrationItemFragment from '../fragments/similarIntegrationItemFragment';

export default gql`
  query similarIntegrationItems(
    $integrationID: DokkioID!
    $remoteID: ID!
    $count: Int
  ) {
    similarIntegrationItems(
      integrationID: $integrationID
      remoteID: $remoteID
      count: $count
    ) {
      ...similarIntegrationItemFragment
    }
  }
  ${similarIntegrationItemFragment}
`;
